export const MENU_TOGGLED = 'MENU_TOGGLED';
export const MENU_ACTIVATED = 'MENU_ACTIVATED';
export const MENU_DEACTIVATED = 'MENU_DEACTIVATED';

export const menuToggledCreator = (sliceId, menuIndex) => ({
  type: MENU_TOGGLED,
  payload: {
    sliceId,
    menuIndex,
  },
});

export const menuActivatedCreator = (sliceId, menuIndex) => ({
  type: MENU_ACTIVATED,
  payload: {
    sliceId,
    menuIndex,
  },
});

export const menuDeactivatedCreator = (sliceId, menuIndex) => ({
  type: MENU_DEACTIVATED,
  payload: {
    sliceId,
    menuIndex,
  },
});
